import {SlideBase} from './SlideBase';
import {SlideProps} from './tipos';
import {logoUrl, LOGOS, PLANOS_RESIDENCIAIS} from './dados';
import {Midia} from '../midia';

export function SlidePlanos({vertical}: SlideProps) {
	return (
		<SlideBase vertical={vertical}>
			<div className="slide-planos">
				<div className="slide-titulo">
					<span className="slide-sobretitulo">Planos residenciais</span>
					<h1>Internet rápida com<br/>TV e streaming inclusos</h1>
				</div>
				<div className="slide-planos-cards">
					{PLANOS_RESIDENCIAIS.map((plano, i) => (
						<div key={plano.nome} className={`slide-plano ${plano.destaque ? 'slide-plano-destaque' : ''}`} style={{animationDelay: `${0.15 + i * 0.12}s`}}>
							{plano.destaque && <span className="slide-plano-tag">Mais pedido</span>}
							<div className="slide-plano-nome">{plano.nome}</div>
							<div className="slide-plano-mega"><strong>{plano.mega}</strong><span>mega</span></div>
							<ul className="slide-plano-itens">
								{plano.itens.map(item => <li key={item}>{item}</li>)}
							</ul>
							<div className="slide-plano-logos">
								{plano.logos.map(id => (
									<span key={id} className="slide-logo-chip"><Midia src={logoUrl(id)} alt={LOGOS[id].nome}/></span>
								))}
							</div>
							<div className="slide-plano-preco">
								<small>por apenas</small>
								<div><span className="slide-plano-rs">R$</span><strong>{plano.preco}</strong><span className="slide-plano-centavos">,{plano.centavos}</span><small>/mês</small></div>
							</div>
						</div>
					))}
				</div>
				<p className="slide-rodape-nota">E mais combos com HBO Max, Telecine, Prime Video e Premiere. Pergunte no atendimento.</p>
			</div>
		</SlideBase>
	);
}
